import DropdownOptions from "../../constants/DropdownOptions";
import { MAINFARM, SUBFARM } from "./action";

const initialState = {
  FarmsList: [],
  farmCreated: {},
  selectedFarm: {},
  farmUpdated: {},
  MainFarmsList: [],
  MainFarmId: DropdownOptions.ALL_MAIN_FARM.id
};

export default function FarmManagementReducer(state = initialState, action) {
  switch (action.type) {
    case SUBFARM.list.success:
      return Object.assign({}, state, {
        FarmsList: action.data,
        farmCreated: {},
        farmUpdated: {}
      });
    case SUBFARM.create.success:
      return Object.assign({}, state, {
        farmCreated: action.data
      });
    case SUBFARM.edit.success:
      return {
        ...state,
        selectedFarm: action.data
      };
    case SUBFARM.update.success:
      return {
        ...state,
        farmUpdated: action.data
      };
    case "SUB_FARM_ID":
      return Object.assign({}, state, {
        SubFarmId: action.data
      });
    // case "FILLING_FORM_MODE":
    //     return Object.assign({}, state, {
    //       FillingForm: action.data
    //     });
    case MAINFARM.list.success:
      return Object.assign({}, state, {
        MainFarmsList: action.data
      });
    case "MAIN_FARM_ID":{
      return Object.assign({}, state, {
        MainFarmId: action.data
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/farmManagement/reducer.js